import {Toast} from "vant";
const now = Date.now || function () {
    return new Date().getTime();
};
const today = function () {
    let d = new Date();
    let localYear = d.getFullYear();
    let localMonth = d.getMonth() + 1;
    let localDay = d.getDate();
    return localYear + "-" + localMonth + "-" + localDay;
};
const nextMonthTime = function () {
    let d = Date.now();
    let n = d + 5184000000;
    let thirtyDaysLater = new Date(n);
    let localYear = thirtyDaysLater.getFullYear();
    let localMonth = thirtyDaysLater.getMonth() + 1;
    let localDay = thirtyDaysLater.getDate();
    return localYear + "-" + localMonth + "-" + localDay;
};
const timeObj = function (dateString = today()) {
    let _s = dateString.toString();
    let string = _s.replace(/-/g, "/");
    let _string = _s.replace(" ", "T");
    let d = new Date(string);
    const localTime = ["日", "一", "二", "三", "四", "五", "六"];
    let localWeek = localTime[d.getDay()];
    let localYear = d.getFullYear();
    let localMonth = d.getMonth() + 1;
    let localDay = d.getDate();
    let localDate = localMonth + "月" + localDay + "日";
    let simpleDate = localMonth + "." + localDay;
    let totalData = localYear + "年" + localDate;
    let NumberDate = _string.split("T")[0];
    let numberTime = _string.split("T")[1] ? _string.split("T")[1].slice(0, 5) : "";
    let simpleLocalData = localDate + numberTime;
    let totalLocalDate = totalData + numberTime;
    return {localWeek, localDate, NumberDate, simpleDate, totalData, simpleLocalData, totalLocalDate};
};
const getTimeString = function (timeString) {
    let string = timeString;
    string = string.replace("T", " ").replace("T", "").slice(0, 16);
    return string;
};
const nextTimeObj = function (dateString = today(), dayNum = 1) {
    let d = new Date(dateString.toString());
    let dayNumReset = dayNum - 0;
    let n = d.setDate(d.getDate() + dayNumReset);
    let nString = new Date(n).toISOString();
    return timeObj(nString);
};
const inner3Days = function (startTimeString) {
    let d = new Date(startTimeString.toString().replace(/-/g, "/"));
    console.log(d);
    let t = d.getTime();
    let prevT = t - 259200000;
    let now = Date.now();
    return prevT < now && now < t;
};
const isArray = Array.isArray || function (obj) {
    return obj instanceof Array;
};
const randomString = function (length = 32, chars = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ") {
    var result = "";
    for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
    return result;
};
const successResponse = function (resolve, reject, data, checkArray) {
    if (data.data === null) {
        reject("暂无数据");
    } else if (data.data === "timeout") {
        reject("timeout");
    } else if (checkArray && !(isArray(data.data))) {
        reject("返回数据格式错误");
    } else {
        resolve(data);
        hideLoading();
    }
};
const hideLoading = function () {
    setTimeout(() => {
        //uni.hideLoading();
    }, 500);
};
const successPutResponse = function (resolve, reject, data) {
    if (data.data === "OK") {
        resolve(data);
        setTimeout(() => {
            //uni.hideLoading();
        }, 500);
    } else {
        reject("暂无数据");
    }
};
const requestSuccess = async function (res, checkArray = false) {
    return await new Promise((resolve, reject) => {
        if (res.status === 200 && res.data.code === 1000) {
            successResponse(resolve, reject, res.data, checkArray);
        } else {
            reject(res.data.msg ? res.data.msg : "请求错误或无数据");
        }
    });
};
const requestEmptySuccess = async function (res, isNull = true) {
    return await new Promise((resolve, reject) => {
        if (res.status === 200 && res.data.code === 1000) {
            if (!isNull) {
                resolve(res.data);
            } else {
                if (res.data) {
                    resolve(res.data);
                } else {
                    reject(res.data.msg ? res.data.msg : "请求错误或无数据");
                }
            }
            hideLoading();
        } else {
            reject(res.data.msg ? res.data.msg : "请求错误或无数据");
        }
    });
};
const requestPostSuccess = async function (res, method, checkArray = false) {
    return await new Promise((resolve, reject) => {
        if (method === "POST") {
            if (res.statusCode === 201 && res.data.code === 1000) {
                successResponse(resolve, reject, res.data, checkArray);
            } else {
                reject(res.data.desc ? res.data.desc : "请求错误或无数据");
            }
        } else if (method === "PUT") {
            if (res.statusCode === 200 && res.data.code === 1000) {
                successPutResponse(resolve, reject, res.data);
            } else {
                reject(res.data.desc ? res.data.desc : "请求错误或无数据");
            }
        }
    });
};
const requestNull = function (err) {
    //Toast(err);
    // //uni.hideLoading();
    // //uni.showToast({
    //   title: err || "暂无数据！",
    //   duration: 3000,
    //   icon: "none"
    // });
};
const requestError = function (err) {
    if (err) {
        Toast(err.message);
    }
    // //uni.hideLoading();
    // //uni.showToast({
    //   title: err ? err.errMsg ? err.errMsg : err : "请求错误",
    //   duration: 2000,
    //   icon: "none"
    // });
};
const requestTimeOut = function (err, logout = () => {}, setTimeOut = () => {}) {
    logout();
    setTimeOut(true);
    Toast(err);
    //hideLoading();
    // //uni.showModal({
    //   title: "提示",
    //   content: "登录失效，请重新登录",
    //   showCancel: false,
    //   success: function (res) {
    //     if (res.confirm) {
    //       //uni.navigateTo({
    //         url: "/pages/user/user"
    //       });
    //     }
    //   }
    // });
};
const resError = function (err, checkTimeOut = false, logout = () => {}, setTimeOut = () => {}) {
    if (checkTimeOut && err === "timeout") {
        requestTimeOut(err, logout, setTimeOut);
        return;
    }
    if (err === "timeout") {
        err = "";
    }
    requestNull(err);
};
const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const encode = function (input) {
    var output = "";
    var chr1, chr2, chr3 = "";
    var enc1, enc2, enc3, enc4 = "";
    var i = 0;
    do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }
        output = output + keyStr.charAt(enc1) + keyStr.charAt(enc2)
            + keyStr.charAt(enc3) + keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);
    return output;
};
const decode = function decode64(input) {
    var output = "";
    var chr1, chr2, chr3 = "";
    var enc1, enc2, enc3, enc4 = "";
    var i = 0;
    if (input.length % 4 !== 0) {
        return "";
    }
    var base64test = /[^A-Za-z0-9\+\/\=]/g;
    if (base64test.exec(input)) {
        return "";
    }
    do {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 !== 64) {
            output += String.fromCharCode(chr2);
        }
        if (enc4 !== 64) {
            output += String.fromCharCode(chr3);
        }
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);
    return output;
};
const getStorage = function (key) {
    var $value = JSON.parse(localStorage.getItem(key));
    return key ? isArray(key) ? $value[0][key] : $value : $value;
};
const setStorage = function (key, value) {
    var itemToJson = JSON.stringify(value);
    localStorage.setItem(key, itemToJson);
};
const removeStorage = function (key) {
    localStorage.removeItem(key);
};
const objToFormData = function (obj) {
    let foo = "?";
    let _arr = Object.keys(obj);
    _arr.map((e, i) => {
        if (i === _arr.length - 1) {
            foo += e + "=" + obj[e];
        } else {
            foo += e + "=" + obj[e] + "&";
        }
    });
    return foo;
};
const waitValue = function () {
    let timer;
    function regetValue(resolve) {
        timer = setTimeout(() => {
            if (!hasValue) {
                regetValue(resolve);
            } else {
                timer = "";
                resolve();
            }
        }, 10);
    }
    return new Promise((resolve) => {
        regetValue(resolve);
    });
};
const openApp2 = function (openUrl, callback) {
    function BrowserInfo() {
        return {
            userAgent: navigator.userAgent.toLowerCase(),
            isAndroid: Boolean(navigator.userAgent.match(/android/ig)),
            isIphone: Boolean(navigator.userAgent.match(/iphone|ipod/ig)),
            isIpad: Boolean(navigator.userAgent.match(/ipad/ig)),
            isWeixin: Boolean(navigator.userAgent.match(/MicroMessenger/ig)),
        };
    }
    //检查app是否打开
    function checkOpen(cb) {
        let _clickTime = +(new Date());
        function check(elsTime) {
            if (elsTime > 3000 || document.hidden || document.webkitHidden) {
                cb(1);
            } else {
                cb(0);
            }
        }
        //启动间隔20ms运行的定时器，并检测累计消耗时间是否超过3000ms，超过则结束
        let _count = 0, intHandle;
        intHandle = setInterval(function () {
            _count++;
            let elsTime = +(new Date()) - _clickTime;
            if (_count >= 100 || elsTime > 3000) {
                clearInterval(intHandle);
                check(elsTime);
            }
        }, 20);
    }
    //在iframe 中打开APP
    let ifr = document.createElement("iframe");
    ifr.src = openUrl;
    ifr.style.display = "none";
    if (callback) {
        //客户端检测微信直接跳应用宝链接
        let browser = BrowserInfo();
        //使用微链接
        let encodeUri = encodeURIComponent(openUrl);
        if (browser.isWeixin) {
            const pathName = openUrl.split("topic2.d1ev.com")[1];
            window.location.href = "https://topic2.d1ev.com/" + pathName;
        } else {
            checkOpen(function (opened) {
                callback && callback(opened);
            });
        }
    }
    document.body.appendChild(ifr);
    setTimeout(function () {
        document.body.removeChild(ifr);
    }, 2000);
};
const openApp = function (pathname) {
    const {id, type} = getUrlInfo(pathname);
    const isWechat = Boolean(navigator.userAgent.match(/MicroMessenger/ig));
    //com.d1ev.app.ev01.D1ev-iOS
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        //window.location.href = "App://com.d1ev.app.ev01.D1ev-iOS";//ios app协议
        let _url;
        if (!id || !type) {
            let {pathname} = window.location;
            _url = "https://topic2.d1ev.com" + pathname;
        } else {
            _url = "https://topic2.d1ev.com" + pathname + "?id=" + id + "&type=" + type;
        }
        window.location.href = _url;//ios app协议
        openApp2(_url, (e) => {
            if (e === 0) {
                window.location.href = "//a.app.qq.com/o/simple.jsp?pkgname=com.d1ev.app.ev01&fromcase=40003";
            }
        });
    } else if (navigator.userAgent.match(/android/i)) {
        let _url;
        if (!id || !type) {
            let {pathname} = window.location;
            _url = "app://com.d1ev.app.ev01?url=" + pathname;
        } else {
            _url = "app://com.d1ev.app.ev01?url=" + pathname + "&id=" + id + "&type=" + type;//android app协议
        }
        if (isWechat) {copyText2(_url);}
        window.location.href = _url;
        window.setTimeout(function () {
            window.location.href = "//a.app.qq.com/o/simple.jsp?pkgname=com.d1ev.app.ev01&fromcase=40003";//android 下载地址
        }, 2000);
    } else {
        pathname ? window.location.href = pathname : "";
    }
};
const getsec = function (str) {
    if (!!!str) {
        return 30 * 60 * 1000;
    }
    var str1 = str.substring(0, str.length - 1);
    var str2 = str.substring(str.length - 1, str.length);
    if (str2 === "s") {
        return str1 * 1000;
    } else if (str2 === "h") {
        return str1 * 60 * 60 * 1000;
    } else if (str2 === "d") {
        return str1 * 24 * 60 * 60 * 1000;
    }
};
const setCookie = function (name, value, time) {
    var strsec = getsec(time);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
};
const getCookie = function (name, serverCookie) {
    let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    let arr;
    if (serverCookie) {
        arr = serverCookie.match(reg);
    } else {
        arr = document.cookie.match(reg);
    }
    if (Array.isArray(arr)) {
        return unescape(arr[2]);
    } else {
        return "";
    }
};
const inquiryPrice = function (id, name) {
    if (window.d1ev && window.d1ev.inquiry) {
        window.d1ev.inquiry(id, name);
    }
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.inquiry) {
        window.webkit.messageHandlers.inquiry.postMessage({"seriesID": id, "seriesName": name});
    }
};
const openOriginal = function (id, type, name) {
    var params;
    console.log(id, type);
    if (type === 8) {
        params = JSON.stringify({"seriesId": id.toString(), "seriesName": name});
        if (window.d1ev) {
            startActivity("com.d1ev.app.ev01.activity.CarSeriesDetailActivity", params);
        }
        if (window.webkit && window.webkit.messageHandlers) {
            startActivity("D1EVCarSeriesController", params);
        }
    } else if (type === 100) {
        inquiryPrice(id, name);
    } else {
        params = JSON.stringify({"targetId": id.toString(), "targetType": type.toString()});
        if (window.d1ev) {
            startActivity("com.d1ev.app.ev01.activity.ArticleDetailActivity", params);
        }
        if (window.webkit && window.webkit.messageHandlers) {
            startActivity("D1EVArticleDetailController", params);
        }
    }
};
const joinModal = function (seriesId, seriesName) {
    var $seriesId = seriesId || "670";
    var $seriesName = seriesName || "Model 3";
    var $api = "//car.m.d1ev.com/car/api/v1001/wap/series/modelList.do";
    var $href = "?seriesId=" + $seriesId + "&type=2&fromType=1";/*type1所有2在售formTy1询价2试驾*/
    if (navigator.userAgent.indexOf("D1EViOS") !== -1 || navigator.userAgent.indexOf("D1EVAndroid") !== -1) {openOriginal($seriesId - 0, 100, $seriesName);} else {window.location.href = $api + $href;}
};
const resetLargeNum = function (number) {
    let fr = 1000;
    let num = 3;
    if (number) {
        while (number / fr >= 1) {
            fr *= 10;
            num += 1;
        }
        if (num <= 4) {
            return number;
        } else {
            return parseFloat(number / 10000).toFixed(1) + "万";
        }
    } else {
        return 0;
    }
};
const getRequest = function () {
    let url = location.search;
    let theRequest = {};
    if (url.indexOf("?") !== -1) {
        let str = decodeURI(url.substr(1));
        let strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest;
};
const resetPhoneNum = function (str, frontLen = 3, endLen = 4) {
    let len = str.length - frontLen - endLen;
    let xing = "";
    for (var i = 0; i < len; i++) {
        xing += "*";
    }
    return str.substr(0, frontLen) + xing + str.substr(str.length - endLen);
};
const confirmApp = function (url, next) {
    const _isOpenApp = getCookie("openApp");
    if (!_isOpenApp) {
        const r = confirm("打开APP观看体验更好！");
        if (r === true) {
            setCookie("openApp", "app", "1d");
            next(false);
            openApp(url);
        } else {
            setCookie("openApp", "local", "1d");
            if (next) {
                next();
            } else {
                url ? window.location.href = url : "";
            }
        }
    } else {
        if (_isOpenApp === "app") {
            next(false);
            openApp(url);
        } else {
            if (next) {
                next();
            } else {
                url ? window.location.href = url : "";
            }
        }
    }
};
const getUrlInfo = function (url) {
    let id, type;
    console.log("pathname:");
    console.log(url);
    //车系页  8 文章页: 新闻  1 大牛  6 车讯  10 视频页 2 口碑  33 评测 32 成交价 41 图文 24 小视频  23 话题详情  25 圈子详情 38 个人主页  21
    id = (/\/\d+/g).test(url) ? url.match(/\/\d+/g)[0].split("/")[1] - 0 : 0;
    switch (true) {
        case (/\/audi-series-\d+/g).test(url):
            //https://m.d1ev.com/news/qiye/161902
            id = url.match(/-\d+\//g)[0]?.match(/\d+/g)[0] - 0;
            type = 8;
            break;
        case (/\/news\//g).test(url):
            //https://m.d1ev.com/news/qiye/161902
            type = 1;
            break;
        case (/\/kol\//g).test(url):
            //https://m.d1ev.com/kol/161160
            type = 6;
            break;
        case (/\/carnews\//g).test(url):
            //https://m.d1ev.com/carnews/pingce/161878
            type = 10;
            break;
        case (/\/video\//g).test(url):
            //https://m.d1ev.com/video/161735
            type = 2;
            break;
        case (/\/koubei\/detail\//g).test(url):
            //https://m.d1ev.com/car/koubei/detail/725-7668/
            id = url.match(/\d+\//g)[0].split("/")[0] - 0;
            type = 33;
            break;
        case (/\/evalution\//g).test(url):
            //https://m.d1ev.com/evalution/9
            type = 32;
            break;
        case (/\/price-\d+/g).test(url):
            //http://car.m.d1ev.com/price-725-1051-0/
            id = url.match(/-\d+/g)[1].split("-")[1] - 0;
            type = 41;
            break;
        case (/\/circle\/detail\/\d+\/article/g).test(url):
            //https://app2.d1ev.com/circle/detail/4520/article
            type = 24;
            break;
        case (/\/circle\/detail\/\d+\/video/g).test(url):
            //https://app2.d1ev.com/circle/detail/4508/video
            type = 23;
            break;
        case (/\/circle\/list\/\d+\/subject/g).test(url):
            //https://app2.d1ev.com/circle/list/55/subject
            type = 25;
            break;
        case (/\/circle\/list\/\d+\/circle/g).test(url):
            //https://app2.d1ev.com/circle/list/3/circle
            type = 38;
            break;
        case (/\/user\/\d+/g).test(url):
            //https://m.d1ev.com/user/230296
            type = 21;
            break;
        default:
    }
    return {id, type};
};
const replaceStringUrlToTag = function (string) {
    let urlArray = [];
    let i = 0;
    const reg1 = /\r\n/g;
    const reg = /(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/g;
    return string.replace(reg1, "<br>").replace(reg, function () {
        let matchedStr = arguments[0];
        urlArray[i] = matchedStr;
        i++;
        return "<a class='link-tip' href=" + matchedStr + ">" + "<span class='img--wrapper'><img src='//www.d1ev.com/special/circle/images/link-tip.png' alt=''></span>" + "网络链接</a>";
    });
};
const copyText2 = function (str) {
    let save = function (e) {
        e.clipboardData.setData("text/plain", str);
        e.preventDefault();//阻止默认行为
    };
    document.addEventListener("copy", save);
    document.execCommand("copy");
};
export default {
    now,
    today,
    nextMonthTime,
    timeObj,
    nextTimeObj,
    getTimeString,
    inner3Days,
    isArray,
    requestSuccess,
    requestPostSuccess,
    requestEmptySuccess,
    resError,
    requestNull,
    requestError,
    requestTimeOut,
    encode,
    decode,
    randomString,
    getStorage,
    setStorage,
    removeStorage,
    objToFormData,
    waitValue,
    openApp,
    setCookie,
    getCookie,
    inquiryPrice,
    openOriginal,
    joinModal,
    resetLargeNum,
    getRequest,
    resetPhoneNum,
    confirmApp,
    getUrlInfo,
    replaceStringUrlToTag
};